// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"/js/main.script": 0,
	"css/main.style": 0,
	"components/countries/countries": 0,
	"components/content/content": 0,
	"components/block/block": 0,
	"components/block--parceria/block--parceria": 0,
	"components/webform/webform": 0,
	"components/paragraph--texto-com-titulo/paragraph--texto-com-titulo": 0,
	"components/paragraph--texto-com-imagem/paragraph--texto-com-imagem": 0,
	"components/paragraph--rotulo-e-valor/paragraph--rotulo-e-valor": 0,
	"components/paragraph--hero-banner/paragraph--hero-banner": 0,
	"components/paragraph--cta/paragraph--cta": 0,
	"components/pager/pager": 0,
	"components/navbar/navbar": 0,
	"components/gallery/gallery": 0,
	"components/form/form": 0
};

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };

// install a JSONP callback for chunk loading
var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
	var chunkIds = data[0];
	var moreModules = data[1];
	var runtime = data[2];
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunkradix_subtheme"] = self["webpackChunkradix_subtheme"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));